import { render, staticRenderFns } from "./PhysicalBooks.vue?vue&type=template&id=e7a0f8d6&scoped=true&"
import script from "./PhysicalBooks.vue?vue&type=script&lang=js&"
export * from "./PhysicalBooks.vue?vue&type=script&lang=js&"
import style0 from "./PhysicalBooks.vue?vue&type=style&index=0&id=e7a0f8d6&RegisterBooksHomeang=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a0f8d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VIcon,VTab,VTabItem,VTabs})
